import React, { useState, useEffect } from 'react';
import {
    Box,
    Grid,
    Button,
    // Select,
    // TextField,
    // MenuItem,
    // FormControl,
    FormControlLabel,
    Checkbox,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions
} from '@mui/material';
import PropTypes from 'prop-types';
import { deviceColumnOptions } from 'utils/constants';

const EditDeviceColumnsVisibilityDialog = ({ onClose, onSubmit, data }) => {
    const [columns, setColumns] = useState(data);
    const handleChange = (e) => {
        setColumns({
            ...columns,
            [e.target.name]: e.target.checked
        });
    };
    return (
        <Dialog open={true} onClose={onClose}>
            <DialogTitle sx={{ fontSize: '18px' }}>Edit Device Order Columns</DialogTitle>
            <DialogContent sx={{ minWidth: '500px' }}>
                <Box sx={{ mb: 3, mt: 3 }}>
                    <Grid container>
                        {deviceColumnOptions.map((column, key) => (
                            <Grid item xs={4} key={key}>
                                <FormControlLabel
                                    control={<Checkbox name={column.value} checked={columns[column.value]} onChange={handleChange} />}
                                    label={column.label}
                                />
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button variant="outlined" onClick={() => onSubmit(columns)}>
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
};

EditDeviceColumnsVisibilityDialog.propTypes = {
    onClose: PropTypes.func,
    onSubmit: PropTypes.func,
    data: PropTypes.object
};

export default EditDeviceColumnsVisibilityDialog;
